import styled from 'styled-components'
import Icon from 'components/Icon.v2'

export const HeaderContainer = styled.div`
  color: #ffffff;
  position: relative;
  padding-right: 350px;
  min-height: 250px;
`

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 0 35px;
`

export const CoverImageContainer = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 345px;
`

export const VenueName = styled.h1`
  margin-top: 40px;
  font-size: 24px;
`

export const Tags = styled.section`
  margin-top: 10px;
  font-size: 11px;
  line-height: 125%;
  font-weight: 300;
  text-transform: uppercase;
`

export const ActionsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 16px;
`

export const Description = styled.section`
  margin-top: 15px;
  max-width: 520px;
  font-size: 13px;
  font-weight: 300;
`

export const FavouriteButton = styled.button`
  outline: none;
  display: flex;
  align-items: center;

  color: var(--White, #fff);
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;

  height: 36px;
  padding: 8px 16px;
  border-radius: 8px;
  background: var(--Orange--1, #d95c1e);

  &:focus {
    outline: none;
  }
`

export const FavouriteIcon = styled(Icon)`
  margin-right: 10px;
`

export const DiscountButton = styled.button`
  display: inline-flex;
  border: none;
  padding: 11px 15px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 13px;
  font-weight: 300;
`

export const DiscountIcon = styled(Icon)`
  margin-right: 10px;
`

export const OrderPartyButton = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
`
